"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompanyProfileSchema = void 0;
const zod_1 = require("zod");
const company_constant_1 = require("./company.constant");
exports.CompanyProfileSchema = zod_1.z.object({
    businessDescription: company_constant_1.BusinessDescriptionSchema.optional(),
    capital: company_constant_1.CapitalSchema.optional(),
    ceo: company_constant_1.CeoSchema.optional(),
    companyLogo: company_constant_1.CompanyLogoUrlSchema.optional(),
    companyName: company_constant_1.CompanyNameSchema,
    corporateWebsite: company_constant_1.CorporateWebsiteSchema.optional(),
    establishment: company_constant_1.EstablishmentSchema.optional(),
    office: company_constant_1.OfficeSchema.optional(),
});
